import * as RDialog from '@radix-ui/react-dialog';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { forwardRef } from 'react';
import { Icon } from '@/design-system/icon/Icon';
import styles from './Dialog.module.css';

export const Dialog = RDialog.Root;
export const DialogTrigger = RDialog.Trigger;
export const DialogClose = RDialog.Close;

interface DialogContentProps extends ComponentPropsWithoutRef<typeof RDialog.Content> {
  children: ReactNode;
  width?: number;
}

export const DialogContent = forwardRef<HTMLDivElement, DialogContentProps>(
  ({ children, width, className, style, ...rest }, ref) => (
    <RDialog.Portal>
      <RDialog.Overlay className={styles.overlay} />
      <RDialog.Content
        ref={ref}
        className={`${styles.content} ${className ?? ''}`}
        style={width ? { ...style, width, maxWidth: `calc(100vw - 32px)` } : style}
        {...rest}
      >
        {children}
        <RDialog.Close className={styles.closeBtn} aria-label="Sluiten">
          <Icon name="close" size={14} />
        </RDialog.Close>
      </RDialog.Content>
    </RDialog.Portal>
  ),
);
DialogContent.displayName = 'DialogContent';

export const DialogTitle = forwardRef<
  HTMLHeadingElement,
  ComponentPropsWithoutRef<typeof RDialog.Title>
>(({ className, ...rest }, ref) => (
  <RDialog.Title ref={ref} className={`${styles.title} ${className ?? ''}`} {...rest} />
));
DialogTitle.displayName = 'DialogTitle';

export const DialogDescription = forwardRef<
  HTMLParagraphElement,
  ComponentPropsWithoutRef<typeof RDialog.Description>
>(({ className, ...rest }, ref) => (
  <RDialog.Description ref={ref} className={`${styles.description} ${className ?? ''}`} {...rest} />
));
DialogDescription.displayName = 'DialogDescription';

export function DialogFooter({ children }: { children: ReactNode }) {
  return <div className={styles.footer}>{children}</div>;
}

export function DialogBody({ children }: { children: ReactNode }) {
  return <div className={styles.body}>{children}</div>;
}
